import camelCase from 'lodash.camelcase';

export default (values, props, json) => {
    const { messages } = props;

    if (json && json.errors) {
        const errors = {};
        json.errors.forEach(({ errorKey }) => {
            const messageKey = camelCase(errorKey.replace('ERR_', ''));
            const message = messages.errors[messageKey];
            if (message) {
                errors.code = message();
            } else {
                errors.code = messages.errors.invalid({
                    field: messages.promotionForm.code()
                });
            }
        });

        return errors;
    }

    return { _error: messages.errors.unknown() };
};
